import React, { Component } from "react"
import { connect } from 'react-redux'
import { Input } from "../core";
import { saveTransactionAction } from '../../redux/actions/MainAction'
import {
    UploadPanel,
    UploadList
}
    from ".."

import { msg } from '../Notifications/MsgBox';
import { UploadPanelCommittee } from "../Upload";

class DocumentNotApproveModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            selectedFile: null,
            file: null,
            file_id:null
        }
        this.closeModal = this.closeModal.bind(this)
        //this.onChangeSelectedFile = this.onChangeSelectedFile.bind(this)
        //this.closeModal = this.closeModal.bind(this)
        this.onUploadComplete = this.onUploadComplete.bind(this)
        this.onUploadCancel = this.onUploadCancel.bind(this)
    }

    closeModal(modelId) {
        let { selectedFile } = this.state
        this.setState({
            selectedFile: ''
        })
            //this.props.closeModel(modelId)
        this.onUploadCancel(modelId)
    }
    onValidate = (file, file_type) => {
        const { upload_files } = this.props
        if (file == null) {
            msg.error('กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
            return false
        } else {
            let isDupplicateFile = false
            isDupplicateFile = upload_files && upload_files.some(f => f.file_name === file.name && f.file_category === file_type)
            if (isDupplicateFile) {
                msg.error('ไม่สามารถอัพโหลดไฟล์ชื่อเดียวกันได้')
                return false
            }
        }
        this.setState({
            selectedFile: file
        })
        return true
    }
    onChangeSelectedFile = (file, file_type) => {
        this.setState({
            selectedFile: file
        })

        this.props.onChangeSelectedFile(file, file_type) 

    }

    onUploadComplete = (modalId) => {     
        this.props.onUploadComplete(modalId)
        
        const modalElement = document.getElementById(modalId);

        if(modalElement)
        {
            window.$(modalElement).modal('hide');
        }
    }
    
    onUploadCancel = (modalId) => {     
        this.props.onUploadCancel(modalId)

        const modalElement = document.getElementById(modalId);

        if(modalElement)
        {
            window.$(modalElement).modal('hide');
        }
    }

    render() {
        console.log("DocumentModal.render()")
        let { selectedFile } = this.state
        return (
            <div>
                <div className="modal fade sp-modal rrs-modal" id={this.props.model_id} tabIndex={-1} role="dialog" aria-labelledby={this.props.model_id} aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id={this.props.model_id+"Label"}>Attachments</h5>
                                <button type="button" className="close" data-dismiss="modal" onClick={()=>this.closeModal(this.props.model_id)} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <UploadPanelCommittee
                                    transaction_no={this.props.transaction_no}
                                    file_category={this.props.file_category ?? 'CM'}
                                    file_transaction_no = {this.props.dataId}
                                    onValidate={(selectedFile) => this.onValidate(selectedFile, this.props.file_category ?? 'CM')}
                                    onChangeSelectedFile={(selectedFile) => this.onChangeSelectedFile(selectedFile, this.props.file_category ?? 'CM')}
                                    onUploadComplete={() => this.onUploadComplete('attachedCancelMomModal')}
                                    onUploadCancel={() => this.onUploadCancel('attachedCancelMomModal')}
                                    defaultFileName={this.props.defaultFileName ?? 'เอกสารประกอบการยกเลิก MOM'}
                                    selectedFile={selectedFile}
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, UploadRedux } = state
    return {
        transaction: MainRedux.transaction,
        upload_files: UploadRedux.upload_files,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DocumentNotApproveModal)